module.exports = __webpack_public_path__ + "img/1.ca2b5858.png";